export default __webpack_public_path__ + "static/media/googlebooksearch.0162597c.png";